<template>
  <div class="container-cental">
    <h1 class="mt-5 mb-5">{{ $t("messages.listoOfAgendas").toUpperCase() }}</h1>
    <div class="container-actions-top-table">
      <div class="container-searcher">
        <b-input-group size="sm" class="mb-2">
          <b-input-group-prepend is-text>
            <b-icon icon="search"></b-icon>
          </b-input-group-prepend>
          <b-form-input
            type="search"
            placeholder="Buscador"
            v-model.trim="textSearch"
          ></b-form-input>
        </b-input-group>
      </div>
      <div class="container-status-filter" style="margin-left: 20px; flex-grow: 1; max-width: 250px;">
        <b-form-select v-model="selectedStatus" :options="statusOptions" size="sm" class="mb-2"></b-form-select>
      </div>
      <div class="container-add-new">
        <b-button variant="primary" @click="showModalAdd = true">Nuevo</b-button>
      </div>
    </div>
    <div class="container-table">
      <b-table
        striped
        :stacked="windowWidth < 600"
        hover
        :items="itemsFiltered"
        :fields="fields"
        :busy="loadingData"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        sort-icon-left
        responsive="sm"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="textSearch.toLowerCase()"
      >
        <template #cell(full_date)="data">
          <span>{{ `${data.item.dia}-${data.item.mes}-${data.item.anio}`}}</span>
        </template>
        <template #cell(hora)="data">
          <span>{{ secondsToHM(data.item.hora)}}</span>
        </template>
        <template #cell(estado)="data">          
          <b-icon
            :icon="data.item.estadoIcon.icon"
            :variant="data.item.estadoIcon.variant"
            scale="1.5"
            style="margin: 0px 10px"
            v-b-tooltip.hover
            :title="data.item.estadoIcon.title"
          ></b-icon>
        </template>
        <template #cell(actions)="data">
          <b-icon
            icon="pencil-square"
            variant="warning"
            @click="editRegister({ ...data.item })"
            scale="1.5"
            style="margin: 0px 10px; cursor: pointer"
            v-b-tooltip.hover
            title="Editar"
          ></b-icon>
          <b-icon
            icon="trash"
            variant="danger"
            @click="deleteItem({ ...data.item })"
            scale="1.5"
            style="margin: 0px 10px; cursor: pointer"
            v-b-tooltip.hover
            title="Eliminar"
          ></b-icon>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong style="margin-left: 5px">Cargando Datos...</strong>
          </div>
        </template>
      </b-table>
    </div>
    <div class="container-paginator">
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
      <span style="margin-left: 15px">Items por página</span>
      <b-form-select
        v-model="perPage"
        :options="optionsPerPage"
        style="width: 80px; margin-left: 10px"
      ></b-form-select>
    </div>
    <ModalAddCiteOfSession :show="showModalAdd" :tiposSession="tiposSession" :sesionistas="sesionistas"
      :husoHorarios="husoHorarios" :sesionistasTipoSesion="sesionistasTipoSesion"
      :disponibilidadSesionistas="disponibilidadSesionistas" :isAdminMode="true" @ok="onModalOk"
      @cancel="showModalAdd = false" />
  </div>
</template>

<script>
import SesionesService from "@/services/sesiones.service";
import EventBus from "@/services/eventBus.js";
import { Helpers } from "@/mixins/Helpers";
import ModalAddCiteOfSession from "@/components/PublicComponents/ModalAddCiteOfSession.vue";
export default {
  name: "AgendamientosList",
  components: {
    ModalAddCiteOfSession,
  },
  mixins: [Helpers],
  data() {
    return {
      sesionesService: null,
      sortBy: "full_date",
      selectedStatus: null,
      statusOptions: [
        { value: null, text: "Todos los estados" },
        { value: 1, text: "Propuesta" },
        { value: 2, text: "Aceptada" },
        { value: 3, text: "Rechazada" },
        { value: 4, text: "Cancelada" },
        { value: 5, text: "Finalizada" },
      ],
      fields: [
        { key: "id", sortable: true, label: "ID" },
        { key: "estado", sortable: true, label: "Estado" },
        { key: "nombres_usuario", sortable: true, label: "Nombre"},
        { key: "apellidos_usuario", sortable: true, label: "Apellido" },
        { key: "full_date", sortable: true, label:"Fecha", thStyle: { minWidth: '110px' }, tdClass: 'text-nowrap' },
        { key: "hora", sortable: true, label:"Hora" },        
        { key: "zona_horaria", sortable: true, label:"Zona Horaria" },
        { key: "email_usuario", sortable: true, label:"Email" },
        { key: "telefono_usuario", sortable: true, label:"Telefono" },
        { key: "hora_canalizadora", sortable: true, label:"Fecha/Hora Canalizadora", tdClass: 'text-nowrap' },
        { key: "sitio_de_encuentro", sortable: true, label:"Sitio de Encuentro" },
        { key: "actions", sortable: false, label:"Acciones" },
      ],
      from: "agendamientoslist",
      items: [],
      windowWidth: window.innerWidth,
      loadingData: false,
      perPage: 10,
      currentPage: 1,
      optionsPerPage: [5, 10, 25, 50, 100],
      textSearch: "",
      itemSeleted: null,
      sortDesc: false,
      showModalAdd: false,
      tiposSession: [],
      sesionistas: [],
      husoHorarios: [],
      sesionistasTipoSesion: [],
      disponibilidadSesionistas: [],
    };
  },
  created() {
    this.sesionesService = new SesionesService();
  },
  mounted() {
    this.getItemsForList();
    this.getInitialDataForModal();
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.windowWidth = window.innerWidth;
      });
    });
    EventBus.$on("RESPONSE_MODAL_QUESTION", (payLoad) => {
      if (payLoad.from == this.from) {
        switch (payLoad.action) {
          case "delete":
            this.ejecuteDelete();
            break;
          case "edit":
            this.goToEdit();
            break;
          default:
            break;
        }
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  },
  methods: {
    onModalOk() {
      this.showModalAdd = false;
      this.getItemsForList();
    },
    getInitialDataForModal() {
      this.sesionesService.getTipoSesiones().then((res) => {
        this.tiposSession = res.data.data;
      });
      this.sesionesService.getSesionistas().then((res) => {
        this.sesionistas = res.data.data;
      });
      this.sesionesService.getHusoHorarios().then((res) => {
        this.husoHorarios = res.data.data;
      });
      this.sesionesService.getSesionistasTipoSesion().then((res) => {
        this.sesionistasTipoSesion = res.data.data;
      });
      this.sesionesService.getDisponibilidadSesionistas().then((res) => {
        this.disponibilidadSesionistas = res.data.data;
      });
    },
    cancelItem(item) {
      this.itemSeleted = { ...item };
      EventBus.$emit("SHOW_MODAL_QUESTION", {
        titleModal: this.$t('messages.elimination'),
        messageModal: "¿Seguro desea eliminar el registro?",
        action: "delete",
        from: this.from,
      });
    },
    deleteItem(item) {
      this.itemSeleted = { ...item };
      EventBus.$emit("SHOW_MODAL_QUESTION", {
        titleModal: "Eliminación",
        messageModal: "¿Seguro desea eliminar el agendamiento?",
        action: "delete",
        from: this.from,
      });
    },
    ejecuteDelete() {
      if (!this.itemSeleted) return false;
      this.sesionesService
        .deleteAgendamiento(this.itemSeleted.id)
        .then((result) => {
          if (result.data.status == 200) {
            this.items = this.items.filter((item) => {
              return item.id != this.itemSeleted.id;
            });
            this.itemSeleted = null;
            EventBus.$emit("MOSTRAR_TOAST", {
              title: "Felicidades",
              variant: "success",
              message: "Registro eliminado satisfactoriamente",
            });
          }
        })
        .catch(() => {
          EventBus.$emit("MOSTRAR_TOAST", {
            title: "Error",
            variant: "danger",
            message: "Error al eliminar registro",
          });
        });
    },
    editRegister(item) {
      this.itemSeleted = { ...item };
      EventBus.$emit("SHOW_MODAL_QUESTION", {
        titleModal: "Edición",
        messageModal: "¿Seguro desea editar el registro?",
        action: "edit",
        from: this.from,
      });
    },
    goToEdit() {
      this.$router
        .push({
          name: "DetalleAgendamiento",
          params: { id: this.itemSeleted.id },
        })
        .catch(() => {});
    },
    getObjectEstado(estado){
      /* 1 - propuesta
      2 - aceptada
      3 - rechazada
      4 - cancelada
      5 - finalizada */
      switch (estado) {
        case 1:
          return {icon:'check-circle',variant:'warning',title:'propuesta'}
        case 2:
          return {icon:'check-circle-fill',variant:'success',title:'aceptada'}
        case 3:
          return {icon:'calendar2-x',variant:'danger',title:'rechazada'}
        case 4:
          return {icon:'trash',variant:'danger',title:'cancelada'}
        case 5:
          return {icon:'trophy',variant:'success',title:'finalizada'}        
        default:
          return {icon:'',variant:'',title:''}        
      }
    },
    getItemsForList() {
      this.loadingData = true;
      this.sesionesService
        .getAllAgendamientos()
        .then((result) => {
          this.items = result.data.data.map((item) => {
            item.estadoIcon = this.getObjectEstado(item.estado);
            item.hora_canalizadora = this.fecha_hora_canalizador(item);
            
            // Generate a sortable date string (YYYY-MM-DD HH:mm)
            const month = item.mes < 10 ? `0${item.mes}` : item.mes;
            const day = item.dia < 10 ? `0${item.dia}` : item.dia;
            const hour = Math.floor(item.hora / 3600);
            const min = Math.floor((item.hora % 3600) / 60);
            const hourStr = hour < 10 ? `0${hour}` : hour;
            const minStr = min < 10 ? `0${min}` : min;
            item.full_date = `${item.anio}-${month}-${day} ${hourStr}:${minStr}`;
            
            return item;
          });
          this.loadingData = false;
        })
        .catch(() => {
          this.loadingData = false;
          EventBus.$emit("MOSTRAR_TOAST", {
            title: "Error",
            variant: "danger",
            message: "Error al recuperar items de la lista",
          });
        });
    },
    fecha_hora_canalizador(item) {  
      
      const dateString = `${item.anio}-${
        item.mes < 10
          ? "0" + item.mes.toString()
          : item.mes.toString()
      }-${
        item.dia < 10
          ? "0" + item.dia.toString()
          : item.dia.toString()
      } ${this.secondsToHM(item.hora)}`;

      const local = this.$moment.tz(dateString, item.zona_horaria);

      const a = local.clone().tz(item.timezoneSesionista);

      return a.format("DD-MM-YYYY HH:mm");
    },
  },
  computed: {
    rows() {
      return this.itemsFiltered.length;
    },
    itemsFiltered() {
      let filtered = [...this.items];

      // Filter by status
      if (this.selectedStatus !== null) {
        filtered = filtered.filter(item => item.estado === this.selectedStatus);
      }

      // Filter by text search (the table also does this, but doing it here ensures 'rows' is accurate)
      if (this.textSearch !== "") {
        const search = this.textSearch.toLowerCase();
        filtered = filtered.filter(item => {
          return (
            (item.nombres_usuario && item.nombres_usuario.toLowerCase().includes(search)) ||
            (item.apellidos_usuario && item.apellidos_usuario.toLowerCase().includes(search)) ||
            (item.email_usuario && item.email_usuario.toLowerCase().includes(search)) ||
            (item.id && item.id.toString().includes(search))
          );
        });
      }

      return filtered;
    },
  },
};
</script>

<style lang="scss" scoped>
.container-cental {
  width: 100%;
  min-height: 700px;
}
.container-table {
  width: 100%;
  min-height: 300px;
  padding-bottom: 20px;
}
.container-paginator {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: baseline;
  width: 100%;
  padding-bottom: 20px;
}
.container-actions-top-table {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  padding: 20px 30px;
}
@media (max-width: 470px) {
  .container-paginator {
    flex-direction: column;
    align-items: center;
  }
}
</style>
